import { ReactNode } from 'react';
import { MdOutlineWarning } from 'react-icons/md';
import { Spinner } from '@ds';

const WARNING_ICON_SIZE = 16;
const APPLY_OVERLAY_BACKGROUND = 'rgba(246, 246, 251, 0.8)';
const NO_ROUTES_FOUND_MESSAGE = 'No routes found with current settings';

type NoRoutesFoundStateProps = {
  message?: string | null;
};

export const NoRoutesFoundState = ({ message }: NoRoutesFoundStateProps) => (
  <div className="w-full flex flex-col items-stretch gap-1 p-2 rounded-lg transition-background">
    <span className="text-m-sb text-base-20 text-center">{message || NO_ROUTES_FOUND_MESSAGE}</span>
  </div>
);

const WarningBanner = ({ children }: { children: ReactNode }) => (
  <div className="w-full flex gap-2 items-center px-4 py-2 bg-warning-80">
    <div className="text-warning-40">
      <MdOutlineWarning size={WARNING_ICON_SIZE} />
    </div>
    <span className="text-s-m text-warning-5">{children}</span>
  </div>
);

export const UnavailableResourcesWarning = () => (
  <WarningBanner>
    <b>Ooops..</b> One or more of the specified resources are unavailable or have been already booked on another case.
    Try other option or regenerate.
  </WarningBanner>
);

export const SurgeonTripsWarning = ({ message }: { message: string }) => <WarningBanner>{message}</WarningBanner>;

type ApplyLoadingOverlayProps = {
  statusText?: string;
};

export const ApplyLoadingOverlay = ({ statusText }: ApplyLoadingOverlayProps) => (
  <div
    className="absolute top-0 left-0 flex flex-col gap-2 justify-center items-center w-full h-full rounded-t-2xl z-10"
    style={{ backgroundColor: APPLY_OVERLAY_BACKGROUND }}
  >
    <Spinner size="md" />
    {!!statusText && <span className="text-m-sb text-base-5">{statusText}</span>}
  </div>
);
